import { render } from "./GroupForm.vue?vue&type=template&id=2039c803&scoped=true"
import script from "./GroupForm.vue?vue&type=script&lang=js"
export * from "./GroupForm.vue?vue&type=script&lang=js"

import "./GroupForm.vue?vue&type=style&index=0&id=2039c803&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\supportgroup\\admin.supportgroup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2039c803"]])

export default __exports__